import type { DetectorCatalogResponse } from '@prerender/diagnostics-api';

import { DETECTOR_QUERIES } from './detectorCatalogLabels';
import DetectorQueriesDialog from './DetectorQueriesDialog';
import InfoIcon from './InfoIcon';
import type { Loadable } from './loadable';

import './diagnostics.css';

const ICON_SIZE = 16;

type DetectorQueriesViewProps = {
  open: boolean;
  catalog: Loadable<DetectorCatalogResponse>;
  onOpen: () => void;
  onClose: () => void;
};

function DetectorQueriesView({ open, catalog, onOpen, onClose }: DetectorQueriesViewProps): JSX.Element {
  return (
    <>
      <button
        type="button"
        className="diagnostics-header-info"
        aria-label={DETECTOR_QUERIES}
        title={DETECTOR_QUERIES}
        onClick={onOpen}
      >
        <InfoIcon size={ICON_SIZE} />
      </button>
      <DetectorQueriesDialog open={open} catalog={catalog} onClose={onClose} />
    </>
  );
}

export default DetectorQueriesView;
